import { render } from "./ResizeObserver.vue?vue&type=template&id=7af30f14&scoped=true"
import script from "./ResizeObserver.vue?vue&type=script&lang=js"
export * from "./ResizeObserver.vue?vue&type=script&lang=js"

import "./ResizeObserver.vue?vue&type=style&index=0&id=7af30f14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af30f14"]])

export default __exports__